/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 22/03/2026 | Lic. José Luis Aragón Cervantes  | Scroll al top al cambiar ruta
*      3       | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Scroll superior en contenedores del dashboard
*      4       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Refresco central de parámetros de caja al iniciar
 *      5       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Ruta de laboratorio de ticket master
 *      6       | 06/06/2026 | Lic. José Luis Aragón Cervantes  | Gate tenant ARSync antes del login
*      7       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Enrutamiento automatico a dashboard y Frm portatiles
 *      8       | 31/08/2026 | Lic. José Luis Aragón Cervantes  | Ruta para registro de fallos
 *  ---------------------------------------------------------------------------------------
 */

import { Route, Routes, useLocation, useSearchParams } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { routeLogin, routeSistem, routeRoot, routeTitles, routeTenantAdminPasswordRecovery } from "../../settings/routeConfig";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";
import { tenantGateStatuses, useSesion } from "../../context/System/SesionContext";

import SizeSoftXAlert from "../utils/SizeSoftXAlert.jsx";
import SizeSoftXFooter from "./SizeSoftXFooter.jsx";
import Login from "../login/Login.jsx";
import FrmRecuperacionPasswordTenant from "../login/FrmRecuperacionPasswordTenant.jsx";
import SizeSoftXDashboard from "./SizeSoftXDashboard.jsx";
import SizeSoftXAppBar from "./SizeSoftXAppBar.jsx";
import FrmVentaSuper from "../../components/ventas/FrmVentaSuper.jsx";
import FrmPreventas from "../../components/ventas/FrmPreventas";
import FrmApartados from "../../components/ventas/FrmApartados.jsx";
import FrmEntradasAlmacenesExhibidores from "../../components/inventarios/FrmEntradasAlmacenesExhibidores.jsx";
import FrmSalidasAlmacenesExhibidores from "../../components/inventarios/FrmSalidasAlmacenesExhibidores.jsx";
import FrmParametrosCaja from "../../components/configuracion/FrmParametrosCaja.jsx";
import FrmParametrosCajaFormMaster from "../../components/configuracion/FrmParametrosCajaFormMaster.jsx";
import FrmExistencias from "../inventarios/FrmExistencias.jsx";
import FrmAdministracionCortes from "../../components/administracion/FrmAdministracionCortes.jsx"
import FrmTraslados from "../../components/inventarios/FrmTraslados.jsx"
import FrmDevoluciones from "../ventas/FrmDevoluciones.jsx";
import FrmArticulos from "../catalogos/articulos/Articulos.jsx"
import FrmAccesos from "../catalogos/accesos/FrmAccesos.jsx"
import FrmClientes from "../catalogos/clientes/FrmClientes.jsx"
import FrmProveedores from "../catalogos/proveedores/FrmProveedores.jsx"
import FrmAlmacenesExhibidores from "../catalogos/almacenesexhibidores/FrmAlmacenesExhibidores.jsx"
import FrmCorridas from "../catalogos/corridas/FrmCorridas.jsx"
import FrmVerificador from "../ventas/FrmVerificador.jsx";
import FrmAsistenciaPiso from "../ventas/FrmAsistenciaPiso.jsx";
import FrmEtiquetado from "../inventarios/FrmEtiquetado.jsx"
import FrmTomaInventario from "../inventarios/toma/FrmTomaInventario.jsx";
import FrmReporteVentasAlmacen from "../administracion/FrmReporteVentasAlmacen.jsx";
import FrmReimpresionCaja from "../administracion/FrmReimpresionCaja.jsx";
import FrmPagoComisiones from "../administracion/FrmPagoComisiones.jsx";
import FrmCompras from "../administracion/compras/FrmCompras.jsx";
import FrmControlAsistencia from "../administracion/FrmControlAsistencia.jsx";
import FrmNominas from "../administracion/FrmNominas.jsx";
import FrmAdministracionDispositivos from "../administracion/FrmAdministracionDispositivos.jsx";
import FrmTenantAdminDashboard from "../administracion/FrmTenantAdminDashboard.jsx";
import FrmCuentasXcobrar from "../administracion/FrmCuentasXcobrar.jsx";
import FrmConteosEscaneo from "../inventarios/toma/conteosescaneo/FrmConteosEscaneo.jsx";
import ConteosInicializacionConFoto from "../inventarios/toma/ConteosInicializacionConFoto.jsx";
import FrmEntrenamientoIAPC from "../ia/EntrenamientoPC/FrmEntrenamientoIAPC.jsx";
import FrmEntrenamientoIAMovil from "../ia/EntrenamientoMovil/FrmEntrenamientoIAMovil.jsx";
import FrmCentroCostosGeneral from "../centrocostos/CentroCostosGeneral.jsx";
import FrmRegistroFallos from "../sistema/FrmRegistroFallos.jsx";
import { useDeviceType, usePortableDevice } from "../../hooks/useDeviceType";
import TenantActivationGate from "../tenant/TenantActivationGate.jsx";
import SizeSoftXDashboardPortatil from "../portatil/leyout/SizeSoftXDashboardPortatil.jsx";
import FrmVentaSuperPortatil from "../portatil/ventas/FrmVentaSuperPortatil.jsx";
import FrmPreventasPortatil from "../portatil/ventas/FrmPreventasPortatil.jsx";
import FrmApartadosPortatil from "../portatil/ventas/FrmApartadosPortatil.jsx";
import FrmEntradasAlmacenesExhibidoresPortatil from "../portatil/inventarios/FrmEntradasAlmacenesExhibidoresPortatil.jsx";
import FrmSalidasAlmacenesExhibidoresPortatil from "../portatil/inventarios/FrmSalidasAlmacenesExhibidoresPortatil.jsx";
import FrmParametrosCajaPortatil from "../portatil/configuracion/FrmParametrosCajaPortatil.jsx";
import FrmParametrosCajaFormMasterPortatil from "../portatil/configuracion/FrmParametrosCajaFormMasterPortatil.jsx";
import FrmExistenciasPortatil from "../portatil/inventarios/FrmExistenciasPortatil.jsx";
import FrmAdministracionCortesPortatil from "../portatil/administracion/FrmAdministracionCortesPortatil.jsx";
import FrmTrasladosPortatil from "../portatil/inventarios/FrmTrasladosPortatil.jsx";
import FrmDevolucionesPortatil from "../portatil/ventas/FrmDevolucionesPortatil.jsx";
import FrmArticulosPortatil from "../portatil/catalogos/articulos/FrmArticulosPortatil.jsx";
import FrmAccesosPortatil from "../portatil/catalogos/accesos/FrmAccesosPortatil.jsx";
import FrmClientesPortatil from "../portatil/catalogos/clientes/FrmClientesPortatil.jsx";
import FrmProveedoresPortatil from "../portatil/catalogos/proveedores/FrmProveedoresPortatil.jsx";
import FrmAlmacenesExhibidoresPortatil from "../portatil/catalogos/almacenesexhibidores/FrmAlmacenesExhibidoresPortatil.jsx";
import FrmCorridasPortatil from "../portatil/catalogos/corridas/FrmCorridasPortatil.jsx";
import FrmVerificadorPortatil from "../portatil/ventas/FrmVerificadorPortatil.jsx";
import FrmAsistenciaPisoPortatil from "../portatil/ventas/FrmAsistenciaPisoPortatil.jsx";
import FrmEtiquetadoPortatil from "../portatil/inventarios/FrmEtiquetadoPortatil.jsx";
import FrmTomaInventarioPortatil from "../portatil/inventarios/toma/FrmTomaInventarioPortatil.jsx";
import FrmReporteVentasAlmacenPortatil from "../portatil/administracion/FrmReporteVentasAlmacenPortatil.jsx";
import FrmReimpresionCajaPortatil from "../portatil/administracion/FrmReimpresionCajaPortatil.jsx";
import FrmPagoComisionesPortatil from "../portatil/administracion/FrmPagoComisionesPortatil.jsx";
import FrmComprasPortatil from "../portatil/administracion/compras/FrmComprasPortatil.jsx";
import FrmControlAsistenciaPortatil from "../portatil/administracion/FrmControlAsistenciaPortatil.jsx";
import FrmCentroCostosGeneralPortatil from "../portatil/centrocostos/FrmCentroCostosGeneralPortatil.jsx";
import FrmEntrenamientoIAPCPortatil from "../portatil/ia/EntrenamientoPC/FrmEntrenamientoIAPCPortatil.jsx";
import FrmEntrenamientoIAMovilPortatil from "../portatil/ia/EntrenamientoMovil/FrmEntrenamientoIAMovilPortatil.jsx";
import ConteosInicializacionConFotoPortatil from "../portatil/inventarios/toma/ConteosInicializacionConFotoPortatil.jsx";

export default function SizeSoftXPage() {
  const { theme } = useConfiguracion();
  const { usuarioEnSesion, handleObtenerParametrosCaja, tenantGateStatus, tenantAdminStatus } = useSesion();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isMobile = useDeviceType();
  const isPortable = usePortableDevice();
  const [gateCompleted, setGateCompleted] = useState(false);
  const isPasswordRecoveryRoute = location.pathname === routeTenantAdminPasswordRecovery;
  const lastTitleRef = useRef("SizeSoftX");
  const parametrosCajaInicioRef = useRef(false);

  const scrollDashboardTop = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    [
      ".content",
      ".dashboard-shell",
      ".dashboard-main",
      ".sizesoftx-dashboard",
    ].forEach((selector) => {
      const element = document.querySelector(selector);
      if (element) element.scrollTop = 0;
    });
  };

  useEffect(() => {
    scrollDashboardTop();
    window.requestAnimationFrame(scrollDashboardTop);
    const timeoutId = window.setTimeout(scrollDashboardTop, 0);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname]);

  useEffect(() => {
    const tituloFormulario = routeTitles[location.pathname] || "SizeSoftX";
    const nuevoTitulo = `SizeSoftX - ${tituloFormulario}`;
    
    if (usuarioEnSesion || location.pathname !== routeLogin) {
      lastTitleRef.current = nuevoTitulo;
    }
    
    if (!usuarioEnSesion && location.pathname === routeLogin) {
      document.title = lastTitleRef.current;
    } else {
      document.title = nuevoTitulo;
    }
  }, [location.pathname, usuarioEnSesion]);

  useEffect(() => {
    if (!usuarioEnSesion) {
      parametrosCajaInicioRef.current = false;
      return;
    }

    if (parametrosCajaInicioRef.current) return;
    parametrosCajaInicioRef.current = true;
    handleObtenerParametrosCaja();
  }, [usuarioEnSesion, handleObtenerParametrosCaja]);

  useEffect(() => {
    if (tenantGateStatus === tenantGateStatuses.AUTHORIZED || tenantGateStatus === tenantGateStatuses.ADMIN_DASHBOARD) {
      const t = setTimeout(() => setGateCompleted(true), 80);
      return () => clearTimeout(t);
    }
    setGateCompleted(false);
  }, [tenantGateStatus]);

  const renderEntrenamientoIA = () => {
    if (!usuarioEnSesion) return <></>;
    const tipo = searchParams.get("tipo");
    if (tipo === "pc") return isPortable ? <FrmEntrenamientoIAPCPortatil /> : <FrmEntrenamientoIAPC />;
    if (tipo === "movil") return isPortable ? <FrmEntrenamientoIAMovilPortatil /> : <FrmEntrenamientoIAMovil />;
    if (isPortable || isMobile) return <FrmEntrenamientoIAMovilPortatil />;
    return <FrmEntrenamientoIAPC />;
  };

  const renderFrm = (FrmDesktop, FrmPortatil) => {
    if (!usuarioEnSesion) return <></>;
    const Formulario = isPortable ? FrmPortatil : FrmDesktop;
    return <Formulario />;
  };

  return (
    <ThemeProvider theme={theme}>
      {!gateCompleted && !isPasswordRecoveryRoute ? (
        <TenantActivationGate />
      ) : (
      <div className={`sizesoftx-dashboard${isPortable ? " sizesoftx-portatil" : ""}`}>
        {usuarioEnSesion && <SizeSoftXAppBar />}
        <div className="content">
          <Routes future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Route path={routeLogin} element={<Login />} />
            <Route path={routeTenantAdminPasswordRecovery} element={<FrmRecuperacionPasswordTenant />} />
            <Route path={routeRoot} element={usuarioEnSesion ? (isPortable ? <SizeSoftXDashboardPortatil /> : <SizeSoftXDashboard />) : tenantAdminStatus ? <FrmTenantAdminDashboard /> : <Login />} />
            <Route path={routeSistem} element={usuarioEnSesion ? <SizeSoftXDashboard /> : <Login />} />
            <Route path="/ventas" element={renderFrm(FrmVentaSuper, FrmVentaSuperPortatil)} />
            <Route path="/preventas" element={renderFrm(FrmPreventas, FrmPreventasPortatil)} />
            <Route path="/apartados" element={renderFrm(FrmApartados, FrmApartadosPortatil)} />
            <Route path="/entradas" element={renderFrm(FrmEntradasAlmacenesExhibidores, FrmEntradasAlmacenesExhibidoresPortatil)} />
            <Route path="/salidas" element={renderFrm(FrmSalidasAlmacenesExhibidores, FrmSalidasAlmacenesExhibidoresPortatil)} />
            <Route path="/parametrosestacion" element={renderFrm(FrmParametrosCaja, FrmParametrosCajaPortatil)} />
            <Route path="/parametrosticketmaster" element={renderFrm(FrmParametrosCajaFormMaster, FrmParametrosCajaFormMasterPortatil)} />
            <Route path="/existencias" element={renderFrm(FrmExistencias, FrmExistenciasPortatil)} />
            <Route path="/cortesdecaja" element={renderFrm(FrmAdministracionCortes, FrmAdministracionCortesPortatil)} />
            <Route path="/traslados" element={renderFrm(FrmTraslados, FrmTrasladosPortatil)} />
            <Route path="/devoluciones" element={renderFrm(FrmDevoluciones, FrmDevolucionesPortatil)} />
            <Route path="/articulos" element={renderFrm(FrmArticulos, FrmArticulosPortatil)} />
            <Route path="/accesos" element={renderFrm(FrmAccesos, FrmAccesosPortatil)} />
            <Route path="/clientes" element={renderFrm(FrmClientes, FrmClientesPortatil)} />
            <Route path="/proveedores" element={renderFrm(FrmProveedores, FrmProveedoresPortatil)} />
            <Route path="/almacenesexhibidores" element={renderFrm(FrmAlmacenesExhibidores, FrmAlmacenesExhibidoresPortatil)} />
            <Route path="/corridas" element={renderFrm(FrmCorridas, FrmCorridasPortatil)} />
            <Route path="/verificador" element={renderFrm(FrmVerificador, FrmVerificadorPortatil)} />
            <Route path="/asistenciapiso" element={renderFrm(FrmAsistenciaPiso, FrmAsistenciaPisoPortatil)} />
            <Route path="/etiquetado" element={renderFrm(FrmEtiquetado, FrmEtiquetadoPortatil)} />
            <Route path="/tomainventario" element={renderFrm(FrmTomaInventario, FrmTomaInventarioPortatil)} />
            <Route path="/reporteventasalmacen" element={renderFrm(FrmReporteVentasAlmacen, FrmReporteVentasAlmacenPortatil)} />
            <Route path="/reimpresioncaja" element={isPortable ? <FrmReimpresionCajaPortatil /> : <FrmReimpresionCaja />} />
            <Route path="/pagocomisiones" element={renderFrm(FrmPagoComisiones, FrmPagoComisionesPortatil)} />
            <Route path="/compras" element={renderFrm(FrmCompras, FrmComprasPortatil)} />
            <Route path="/iaentrenamiento" element={renderEntrenamientoIA()} />
            <Route path="/centrocostos" element={renderFrm(FrmCentroCostosGeneral, FrmCentroCostosGeneralPortatil)} />
            <Route path="/controlasistencia" element={renderFrm(FrmControlAsistencia, FrmControlAsistenciaPortatil)} />
            <Route path="/nominas" element={renderFrm(FrmNominas, FrmNominas)} />
            <Route path="/administraciontenant" element={usuarioEnSesion || tenantAdminStatus ? <FrmTenantAdminDashboard /> : <Login />} />
            <Route path="/administraciondispositivos" element={usuarioEnSesion || tenantAdminStatus ? <FrmAdministracionDispositivos /> : <Login />} />
            <Route path="/cuentasxcobrar" element={renderFrm(FrmCuentasXcobrar, FrmCuentasXcobrar)} />
            <Route path="/conteosescaneo" element={<FrmConteosEscaneo />} />
            <Route path="/conteosinicializacionconfoto" element={renderFrm(ConteosInicializacionConFoto, ConteosInicializacionConFotoPortatil)} />
            <Route path="/registrofallos" element={renderFrm(FrmRegistroFallos, FrmRegistroFallos)} />
          </Routes>
        </div>
        {usuarioEnSesion && <SizeSoftXFooter />}
      </div>
      )}
      <SizeSoftXAlert />
    </ThemeProvider>
  );
}
